import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import {
  getRolePermissions
} from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import WorkFromHomeTable from './WorkFromHomeTable';
import ApplyWorkFromHome from './ApplyWorkFromHome';

function WorkFromHome() {
  const navigate = useNavigate();
  const location = useLocation();

  const [permissions, setPermissions] = useState([]);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Work From Home');
      setPermissions(arr[0].permissions);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Work From Home</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            {location.pathname.includes('/work-from-home/apply') ? 
              <ApplyWorkFromHome permissions={permissions}/> : 
              <WorkFromHomeTable permissions={permissions}/>
            }
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default WorkFromHome;
